// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import FrequentStops from './FrequentStops';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(FrequentStops);
